<template>
  <span class="ml-2">

    <!-- Below tolerance -->
    <span
        v-if="
          getSelectedRisk(impact, probability) <= this.tolerance.number &&
          (this.impact && this.impact.value) &&
          (this.probability && this.probability.value)
        "
    >
      <span class="badge-pill badge-success mr-1">
        <font-awesome-icon icon="check" size="xs"/>
      </span>
      {{ $t('risk.below_tolerance') }}
    </span>

    <!-- Above tolerance -->
    <span
        v-if="
        getSelectedRisk(impact, probability) > this.tolerance.number &&
        (this.impact && this.impact.value) &&
        (this.probability && this.probability.value)
        "
    >
      <span class="badge-pill badge-danger mr-1">
        <font-awesome-icon icon="times" size="xs"/>
      </span>
      {{ $t('risk.above_tolerance') }}
    </span>

    <!-- Missing input -->
    <span class="mr-1"
          v-if="
            (this.impact && !this.impact.value) ||
            (this.probability && !this.probability.value)
          "
    >
      <font-awesome-icon
          icon="exclamation-triangle"
          :class="'risk-9'"
      />
      {{ $t('risk.missing_input') }}
    </span>

  </span>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'RealtimeRisk',
    data: function() {
      return {
        tolerance: {}
      }
    },
    props: {
      impact: {
        type: [Object, Array]
      },
      probability: {
        type: [Object, Array]
      },
      riskTolerance: {},
      riskCategory: {}
    },
    components: {

    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {

      }
    },
    methods: {
      getSelectedRisk(impact, probability) {
        if (impact.value && impact.value == 'Very high' && probability.value && probability.value == 'Very unlikely') {
          return 4
        }
        if (impact.value && impact.value == 'Very high' && probability.value && probability.value == 'Unlikely') {
          return 8
        }
        if (impact.value && impact.value == 'Very high' && probability.value && probability.value == 'Likely') {
          return 12
        }
        if (impact.value && impact.value == 'Very high' && probability.value && probability.value == 'Very likely') {
          return 16
        }

        if (impact.value && impact.value == 'High' && probability.value && probability.value == 'Very unlikely') {
          return 3
        }
        if (impact.value && impact.value == 'High' && probability.value && probability.value == 'Unlikely') {
          return 6
        }
        if (impact.value && impact.value == 'High' && probability.value && probability.value == 'Likely') {
          return 9
        }
        if (impact.value && impact.value == 'High' && probability.value && probability.value == 'Very likely') {
          return 12
        }

        if (impact.value && impact.value == 'Low' && probability.value && probability.value == 'Very unlikely') {
          return 2
        }
        if (impact.value && impact.value == 'Low' && probability.value && probability.value == 'Unlikely') {
          return 4
        }
        if (impact.value && impact.value == 'Low' && probability.value && probability.value == 'Likely') {
          return 6
        }
        if (impact.value && impact.value == 'Low' && probability.value && probability.value == 'Very likely') {
          return 8
        }

        if (impact.value && impact.value == 'Very low' && probability.value && probability.value == 'Very unlikely') {
          return 1
        }
        if (impact.value && impact.value == 'Very low' && probability.value && probability.value == 'Unlikely') {
          return 2
        }
        if (impact.value && impact.value == 'Very low' && probability.value && probability.value == 'Likely') {
          return 3
        }
        if (impact.value && impact.value == 'Very low' && probability.value && probability.value == 'Very likely') {
          return 4
        }
      }
    },
    created () {
      if (this.riskTolerance && !this.riskTolerance.number) {
        this.tolerance.number = 0
      } else {
        this.tolerance = this.riskTolerance
      }
    }
  }
</script>
